// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"265":"component---node-modules-smooth-doc-src-templates-doc-js","322":"component---node-modules-smooth-doc-src-templates-page-js"}[chunkId] || chunkId) + "-" + {"265":"a3cdc4ecb4026240d5bc","322":"a8adad5a7e4bae9a792e","897":"6f90d057043f9e48be85"}[chunkId] + ".js";
};